<template>
    <div>
        AccountNo: {{ accountNo }}<br>
        SubAccountUuid: {{ subAccountUuid }} <br>
        SubAccountPosts: {{ subAccountPosts.length }} <br>
        SubAccountLines: {{ subAccountLines.length }} <br>

        <input>
        <account-picker
            v-model:account-no="accountNo"
            v-model:sub-account-uuid="subAccountUuid"
            v-model:sub-account-posts="subAccountPosts"
            v-model:sub-account-lines="subAccountLines"
            :accounts="[...bookkeepingAccounts, ...suppliers, ...customers]"
        />
        <input>
    </div>
</template>

<script setup lang="ts">

import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {customers, suppliers} from '@/subaccount/subAccount.service'
import {ref} from 'vue'
import AccountPicker from '@/account-picker/AccountPicker.vue'

const accountNo = ref('')
const subAccountUuid = ref('')
const subAccountPosts = ref([])
const subAccountLines = ref([])
</script>

<style scoped>

</style>